import React, { useState, useEffect } from "react";
import Modal from "../common/ModalPopup";
import MultiSelect from "../common/MultiSelect";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getRoleListing } from "../store/slices/RoleUser";
import ReactSelect from "../common/ReactSelect";
import { getMasterConfig } from '../store/slices/common';
import InputField from "../common/InputField"
import { USER_EMAIL_REGEX, USER_MOBILE_REGEX, USER_PASSWORD_REGEX, ROLE_HIERARCHY,COUNTRY_CODE,APP_COUNTRY, MOBILE_NO_LENGTH } from "../config/constant";
import { useLanguage } from "../../src/context/LanguageContext";
import FullPageLoader from '../../src/common/FullPageLoader';
const TickIcon = require('../styles/webroot/images/tick.png')


function AddUserPopup(params: any) {
    let { role_list, addNewUser, showUserRole } = params;
    let [formData, setFormData] = useState<any>({});
    let [userList, setUserList] = useState<any>([]);
    let [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);

    const mobile_regex = USER_MOBILE_REGEX;
    const email_regex = USER_EMAIL_REGEX;
    const password_regex = USER_PASSWORD_REGEX; // eslint-disable-line
    const dispatch: any = useDispatch();
    const commonState = useSelector((state: any) => state.common);
    
    const {translations} = useLanguage();
    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        getUserList();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // Clear dependent fields when assigned_role changes
        setFormData((prev: any) => ({
            ...prev,
            reportee_role_id: '',
            reportee_id: ''
        }));
    }, [formData.assigned_role]);

    
    let verticleData = commonState?.common?.vertical_list??[];
    // add source
    let assignSource = (COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH) ? commonState?.common?.lead_types ?? [] : commonState?.common?.assigned_source ?? [];
    let subAssigneSource = commonState?.common?.sub_lead_types??[];

    let leadSource = commonState?.common?.lead_sources??[];
    let leadSubsource = commonState?.common?.sub_lead_sources??[];
   
    
    
    const getUserList = async () => {
        dispatch(getRoleListing.getUserManagementList({ isPaginationApply: false })).then((res: any) => {
           
            if (res && res.status === 200) {
                let userList = [];
                userList = (res.data && res.data.length && formData) ?
                    res.data.map((e: any) => {
                        let isChecked = formData.reportee_id ? formData.reportee_id === e.id : false;
                        return {
                            value: e.id,
                            label: e.firstname+' '+e.lastname,
                            isChecked: isChecked,
                            assigned_role: e.assigned_role_ids ? e.assigned_role_ids.split(',') : []
                        }
                    }) : [];
                setUserList([...userList]);
            }
        })
    };

    const handleChange = async (key: any, event: any) => {
        let value: any = '';
        let target = event.target;

        if (key === 'status') {
            value = formData.status === 1 ? 0 : 1;
        }
        else if (event instanceof Array) {
            value = event.map((e) => e.value);
        }
        else if (target) {
            value = target.value;
        }
        else if (key === "reportee_role_id") {
            value = event.value || event.id;
            formData["reportee_id"] = null;
        }
        else if (event) {
            value = event.value || event.id;
        }
        formData[key] = value;
        errors[key] = '';
        setFormData({ ...formData });
        setErrors({ ...errors });
    }

    const isFormValid = (formData: any) => {
        let isValid = true;
        if (!formData.reportee_id || formData.reportee_id === '') {
            errors['reportee_id'] = 'Reportee Name is required';
            isValid = false;
        }
        if (!formData.firstname || formData.firstname === '') {
            errors['firstname'] = 'Name is required';
            isValid = false;
        } else if (formData && formData.firstname && (formData.firstname.split('').length < 3 || formData.firstname.split('').length > 30)) {
            errors['firstname'] = 'firstname should be between 3 to 30';
            isValid = false;
        }

        if (!formData.lastname || formData.lastname === '') {
            errors['lastname'] = 'Last is required';
            isValid = false;
        } else if (formData && formData.lastname && (formData.lastname.split('').length < 3 || formData.lastname.split('').length > 30)) {
            errors['lastname'] = 'Name should be between 3 to 30';
            isValid = false;
        }
        
        if (!formData.mobile ||  formData.mobile === '') {
            errors['mobile'] = 'Mobile number is required';
            isValid = false;
        }
        else if(!mobile_regex.test(formData.mobile)){
            errors['mobile'] = (COUNTRY_CODE==='id')?'Mobile number should start from 8 and should be 12 digits.':'Mobile number should start from 9 and should be 10 digits.';
            isValid = false;
        }
        if (!formData.email || formData.email === '') {
            errors['email'] = 'Email is required';
            isValid = false;
        } else if (!email_regex.test(formData.email)) {
            errors['email'] = 'Invalid Email';
            isValid = false;
        }
        if (!formData.password || formData.password === '') {
            errors['password'] = 'Password is required';
            isValid = false;
        } else if (!password_regex.test(formData.password)) {
            errors['password'] = 'Password should be atleast 8 character with 1 special char,1 Uppercase,1 lowercase and 1 digit';
            isValid = false;
        }

        // Sub Assign Source validation
        const showSubAssignSource = subAssigneSource.some((sub: any) =>
            (formData.assign_source || []).includes(sub.lead_type_id)
        );

        // Check if any selected assign_source ID is a sub source
        const selectedSubAssignSources = (formData.assign_source || []).filter((id: number) =>
            subAssigneSource.some((sub: any) => sub.value === id)
        );

        //assign_source
        if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
            if (!formData.assign_source || formData?.assign_source?.length === 0) {
                errors['assign_source'] = 'Assign source is required';
                isValid = false;
            }
        }

        if (showSubAssignSource && selectedSubAssignSources.length === 0) {
            errors['assign_sub_source'] = 'Sub Assign Source is required';
            isValid = false;
        }

        if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
            // sub lead source validation
            const showSubLeadSource = leadSubsource.some((sub: any) =>
                (formData.assign_lead_type || []).includes(sub.lead_source_id)
            );
            // Check if any selected lead source ID is a sub source
            const selectedSubLeadSources = (formData.assign_lead_type || []).filter((id: number) =>
                leadSubsource.some((sub: any) => sub.value === id)
            );
            
            if (!formData.assign_lead_type || formData?.assign_lead_type?.length === 0) {
                errors['assign_lead_type'] = 'Lead source is required';
                 isValid = false;
             }
    
            if (showSubLeadSource && selectedSubLeadSources.length === 0) {
                errors['assign_sub_lead_type'] = 'Sub Lead Source is required';
                isValid = false;
            }
        }


        // add  validation for role
        if (!formData.assigned_role || formData.assigned_role === '') {
            errors['assigned_role'] = 'Role is required';
            isValid = false;
        }
        
        if (!formData.reportee_role_id || formData.reportee_role_id === '') {
            errors['reportee_role_id'] = 'Reportee Role is required';
            isValid = false;
        }

        setErrors({ ...errors });
        return isValid;

    }

    const getFormData = async () => {
        let postData:any = {};
        if (formData && formData.assigned_role) postData['assigned_role'] = formData.assigned_role;
        if (formData && formData.reportee_role_id) postData['reportee_role_id'] = formData.reportee_role_id;
        if (formData && formData.reportee_id) postData['reportee_id'] = formData.reportee_id;
        if (formData && formData.firstname) postData['firstname'] = formData.firstname?.replace(/\s+/g,' ').trim();
        if (formData && formData.lastname) postData['lastname'] = formData.lastname?.replace(/\s+/g,' ').trim();
        if (formData && formData.email) postData['email'] = formData.email?.replace(/\s+/g,' ').trim();
        if (formData && formData.password) postData['password'] = formData.password?.replace(/\s+/g,' ').trim();
        if (formData && formData.mobile) postData['mobile'] = formData.mobile;
        if(formData && formData.status) postData['status'] = +formData.status;
        if(formData && formData.id) postData['id'] = formData.id;

        // combine assign and sub source 
        if (formData && formData.assign_source) postData['assign_source'] = [...(formData.assign_source || []),...(formData.assign_sub_source || []) ];
        if (formData && formData.assign_lead_type) postData['assign_lead_type'] = [...(formData.assign_lead_type || []),...(formData.assign_sub_lead_type || []) ];
        
        
        return postData;
    }
    let user_list : any = []
    if (formData && formData.reportee_role_id) {
        user_list = userList.filter((e: any) => {
            return e.assigned_role?.includes(String(formData.reportee_role_id))
        });
    } 

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true)
        let postData = await getFormData();
        if (isFormValid(postData)) {
            dispatch(getRoleListing.saveUserData(postData)).then((res: any) => {
                if (res && res.status === 200) {
                    toast.success(res.message);
                    setFormData({})
                    params.addNewUser(false);
                    params.getUserManageListDetails({});
                    params.setActiveTab(1)
                    setLoading(false);

                } else {
                    formData.status = 1;
                    setFormData(formData);
                    setLoading(false);
                }
            })
            // }
            params.setSearchText('');
        }else{
            setLoading(false);
        }
    }

    const getFilteredReportingRoles = (selectedRole: any) => {
        if (!selectedRole) return [];

        const allowedReportingRoles: any = ROLE_HIERARCHY[selectedRole] || [];
        return role_list.filter((role: any) => allowedReportingRoles.includes(role.label));
    };
    

    return (

        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="user-screen-popup user-managent-add-user-popup">
                <Modal handleClose={() => addNewUser(false)} show={showUserRole}>
                    <div className="modal-header">
                        <h2>{translations.RuleEngine?.['Add_New_User'] || translations.commonMsg?.loading}</h2>
                    </div>
                    <div className="modal-body" >

                        <div className="row">

                            <div className="add-user-data col-md-12">
                                <Accordion allowZeroExpanded>

                                    <AccordionItem >
                                        <AccordionItemPanel>

                                            <ReactSelect options={verticleData ?? []} value={verticleData?.filter((v: any) => formData['vertical_id'] === Number(v.value))} handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)} placeholder={translations.RuleEngine?.['Business Verticle'] || translations.commonMsg?.loading} fieldKey="vertical_id" errorField={errors?.vertical_id} />

                                        </AccordionItemPanel>
                                    </AccordionItem>

                                    <AccordionItem >
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                1. {translations.RuleEngine?.['Assign_Role'] || translations.commonMsg?.loading} {formData?.assigned_role && <img src={TickIcon} alt="tick" />}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <fieldset className="">

                                                <div className="multiselect-dropDown">
                                                    <li className="searchitems selectWidth form-group">

                                                        <ReactSelect
                                                            options={role_list}
                                                            value={role_list?.find((e: any) => e.value === formData.assigned_role)}
                                                            handleChange={(e: any, fieldKey: string) => {
                                                                handleChange(fieldKey, e)
                                                                // Clear dependent fields when assigned_role changes
                                                                setFormData((prev: any) => ({
                                                                    ...prev,
                                                                    reportee_role_id: '',
                                                                    reportee_id: ''
                                                                }));
                                                            }}
                                                            placeholder={translations.RuleEngine?.['Role'] || translations.commonMsg?.loading}
                                                            fieldKey="assigned_role"
                                                        />
                                                        <span className="error-txt">
                                                            {errors.assigned_role || ""}
                                                        </span>
                                                    </li>
                                                </div>
                                            </fieldset>
                                        </AccordionItemPanel>
                                    </AccordionItem>


                                    <AccordionItem >
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                2. {translations.RuleEngine?.['Reporting'] || translations.commonMsg?.loading} {formData['reportee_role_id'] && formData['reportee_id'] && <img src={TickIcon} alt="tick" />}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>

                                            <ReactSelect
                                                options={getFilteredReportingRoles(role_list?.find((r: any) => r.value === formData.assigned_role)?.label)}
                                                value={formData.reportee_role_id ?
                                                    getFilteredReportingRoles(
                                                        role_list?.find((r: any) => r.value === formData.assigned_role)?.label
                                                    )?.find((v: any) => formData['reportee_role_id'] === v.value) : null}
                                                handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)}
                                                placeholder={translations.RuleEngine?.['Reporting Role'] || translations.commonMsg?.loading}
                                                fieldKey="reportee_role_id" 
                                                key="reportee_role_id"
                                            />
                                            <span className="error-txt">
                                                {errors.reportee_role_id || ""}
                                            </span>

                                            <ReactSelect
                                                options={user_list}
                                                value={user_list?.filter((v: any) => formData['reportee_id'] === Number(v.value))}
                                                handleChange={(e: any, fieldKey: string) => handleChange(fieldKey, e)} placeholder={translations.RuleEngine?.['Reporting Name'] || translations.commonMsg?.loading}
                                                fieldKey="reportee_id" key="reportee_id"
                                                errorField={errors?.reportee_id}
                                            />

                                        </AccordionItemPanel>
                                    </AccordionItem>


                                    <AccordionItem >
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                3. {translations.RuleEngine?.['Basic_Details'] || translations.commonMsg?.loading} {formData['firstname'] && formData['lastname'] && formData['email'] && formData['password'] && formData['mobile'] && <img src={TickIcon} alt="tick" />}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <fieldset className="">
                                                <div className="material">
                                                    <input id="" type="text" placeholder=" " name="firstname" className="form-input" value={formData.firstname || ''} onChange={(e: any) => handleChange("firstname", e)} />
                                                    <label data-label={translations.RuleEngine?.['firstname'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.firstname || ""}
                                                    </span>
                                                </div>
                                            </fieldset>

                                            <fieldset className="">
                                                <div className="material">
                                                    <input id="" type="text" placeholder=" " name="lastname" className="form-input" value={formData.lastname || ''} onChange={(e: any) => handleChange("lastname", e)} />
                                                    <label data-label={translations.RuleEngine?.['lastname'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.lastname || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                            <fieldset className="">
                                                <div className="material">
                                                    <input id="email" type="text" placeholder=" " name="email" className="form-input" value={formData.email || ''} onChange={(e: any) => handleChange("email", e)} />
                                                    <label data-label={translations.RuleEngine?.['Email'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.email || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                            <fieldset className="">
                                                <div className="material">
                                                    <input id="password" type="text" placeholder=" " name="password" className="form-input" value={formData.password || ''} onChange={(e: any) => handleChange("password", e)} />
                                                    <label data-label={translations.RuleEngine?.['Password'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.password || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                            <fieldset className="">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "mobile",
                                                            name: "mobile",
                                                            className: "form-input",
                                                            type: "text",
                                                            value: formData.mobile ? formData.mobile : '',
                                                            maxLength:MOBILE_NO_LENGTH,
                                                            disabled: false,
                                                            placeholder: " "

                                                        }}
                                                        onChange={(e: any) => handleChange("mobile", e)}
                                                    />

                                                    <label data-label={translations.RuleEngine?.['Mobile Number'] || translations.commonMsg?.loading} className="form-label"></label>
                                                    <span className="error-txt">
                                                        {errors.mobile || ""}
                                                    </span>
                                                </div>
                                            </fieldset>
                                        </AccordionItemPanel>
                                    </AccordionItem>

                                    <AccordionItem >
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                4. {translations.RuleEngine?.['Source'] || translations.commonMsg?.loading} {formData['assign_source'] && formData['assign_lead_type'] && <img src={TickIcon} alt="tick" />}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <fieldset className="single-select">
                                                <div className="material">
                                                <MultiSelect
                                                    isSelectAll={true}
                                                    options={assignSource}
                                                    placeholder={translations.RuleEngine?.['Assign Source'] || translations.commonMsg?.loading}
                                                    value={
                                                        (assignSource instanceof Array &&
                                                            formData.assign_source &&
                                                            assignSource.filter((e) =>
                                                                [...(formData.assign_source instanceof Array ? formData.assign_source : [])].includes(e.value)
                                                            )) || []
                                                    }
                                                    onChange={(e: any) => handleChange('assign_source', e)}
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                />
                                                <span className="error-txt">
                                                    {errors.assign_source || ""}
                                                </span>
                                                </div>
                                            </fieldset>

                                            {/* Show only if assign_source has matching sub types */}
                                            {subAssigneSource.some((sub: any) => (formData.assign_source || []).includes(sub.lead_type_id)) && (
                                                <>
                                                    <fieldset className="single-select">
                                                    <div className="material">
                                                        <MultiSelect
                                                            isSelectAll={true}
                                                            options={subAssigneSource.filter((sub: any) => (formData.assign_source || []).includes(sub.lead_type_id))}
                                                            placeholder={translations.RuleEngine?.['Sub Source'] || translations.commonMsg?.loading}
                                                            value={
                                                                (subAssigneSource instanceof Array &&
                                                                    formData.assign_sub_source &&
                                                                    subAssigneSource.filter((e) =>
                                                                        [...(formData.assign_sub_source instanceof Array ? formData.assign_sub_source : [])].includes(e.value)
                                                                    )) || []
                                                            }
                                                            onChange={(e: any) => handleChange('assign_sub_source', e)}
                                                            className="react-select"
                                                            classNamePrefix="react-select"
                                                        />
                                                       
                                                        <span className="error-txt">
                                                            {errors.assign_sub_source || ""}
                                                        </span>
                                                        </div>
                                                    </fieldset>
                                                </>
                                            )}
                                            {
                                                COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH &&
                                                <>
                                                    {/* Lead Source */}
                                                    <fieldset className="single-select">
                                                    <div className="material">
                                                        <MultiSelect
                                                            isSelectAll={true}
                                                            options={leadSource}
                                                            placeholder={translations.RuleEngine?.['Lead Source'] || translations.commonMsg?.loading}
                                                            value={
                                                                (leadSource instanceof Array &&
                                                                    formData.assign_lead_type &&
                                                                    leadSource.filter((e) =>
                                                                        [...(formData.assign_lead_type instanceof Array ? formData.assign_lead_type : [])].includes(e.value)
                                                                    )) || []
                                                            }
                                                            onChange={(e: any) => handleChange('assign_lead_type', e)}
                                                            className="react-select"
                                                            classNamePrefix="react-select"
                                                        />
                                                        <span className="error-txt">
                                                            {errors.assign_lead_type || ""}
                                                        </span>
                                                        </div>
                                                    </fieldset>

                                                    {/* Show only if lead source has matching sub types */}
                                                    {leadSubsource.some((sub: any) => (formData.assign_lead_type || []).includes(sub.lead_source_id)) && (
                                                        <>
                                                            <fieldset className="single-select">
                                                            <div className="material">
                                                                <MultiSelect
                                                                    isSelectAll={true}
                                                                    options={leadSubsource.filter((sub: any) => (formData.assign_lead_type || []).includes(sub.lead_source_id))}
                                                                    placeholder={translations.RuleEngine?.['Lead Sub Source'] || translations.commonMsg?.loading}
                                                                    value={
                                                                        (leadSubsource instanceof Array &&
                                                                            formData.assign_sub_lead_type &&
                                                                            leadSubsource.filter((e) =>
                                                                                [...(formData.assign_sub_lead_type instanceof Array ? formData.assign_sub_lead_type : [])].includes(e.value)
                                                                            )) || []
                                                                    }
                                                                    onChange={(e: any) => handleChange('assign_sub_lead_type', e)}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                />
                                                                <span className="error-txt">
                                                                    {errors.assign_sub_lead_type || ""}
                                                                </span>
                                                                </div>
                                                            </fieldset>
                                                        </>
                                                    )}
                                                </>
                                            }

                                        </AccordionItemPanel>
                                    </AccordionItem>

                                </Accordion>

                            </div>
                            <button className="btn-primary m-md-t" onClick={(e: any) => handleSubmit(e)}>{translations.RuleEngine?.['Add_User'] || translations.commonMsg?.loading}</button>
                        </div>

                    </div>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default AddUserPopup